import { Link } from 'react-router-dom';

const RegisterAsProvider = () => {
  return (
    <section className="pt-13.5 md:pt-20 bg-lightGray !px-4 md:!px-10">
      <div className="max-w-custom mx-auto">
        <div className="text-sm uppercase font-normal font-halyard leading-4.5 text-primaryText text-center py-3 tracking-0.5px">
          Become a partner
        </div>
        <div className="text-6.5 md:text-[3.353em] md:leading-14 font-halyard font-medium text-primaryText text-center">
          Register as a Service Provider
        </div>
        <div className="flex justify-center items-center pb-15 pt-4 md:!pt-6 md:!pb-20">
          <div className="text-center max-w-lg text-md font-normal text-midGray font-dm-sans leading-7 ">
            Join Total Urgent Health today and expand your reach to more
            patients, streamline your operations, and ensure reliable payments.
          </div>
        </div>
        <div className="flex justify-center items-center">
          <Link to={'/register'}>
            <div className="uppercase text-sm font-halyard  font-medium text-white  py-3 px-7  bg-darkBlue hover:bg-primaryBlue cursor-pointer w-fit  tracking-0.5px">
              Register as a Service Provider
            </div>
          </Link>
        </div>
        <div
          className="pt-13.5 md:pt-20 flex flex-col md:items-center items-start sm:flex-row md:space-x-10 pb-10 gap-8"
          id="contact"
        >
          <div className="sm:w-1/2">
            <img src="/health/images/doctorSeto.jpg" alt="doctor" />
          </div>
          <div className="w-full sm:w-1/2">
            <div className="text-sm uppercase font-halyard leading-4.5 font-medium text-primaryText pb-3 tracking-0.5px">
              contact us
            </div>
            <div className="max-w-sm text-6.5 md:text-5xl font-medium text-primaryText tracking-normal leading-12 font-halyard ">
              Have Questions? Get in Touch!
            </div>
            <div className="!pb-[22px] md:!pb-11">
              <div>
                <div className="flex flex-col md:flex-row md:space-x-7.5 gap-y-5 md:gap-y-0 !pt-5 md:!pt-10">
                  <div className="w-full">
                    <input
                      type="text"
                      className="border-b focus:outline-none w-full border-b-midGray  !py-1 md:!py-0 bg-lightGray"
                      placeholder="Name"
                    />
                  </div>
                  <div className="w-full">
                    <input
                      type="text"
                      className="border-b focus:outline-none w-full border-b-midGray  !py-1 md:!py-0 bg-lightGray"
                      placeholder="Last Name"
                    />
                  </div>
                </div>
                <div className="flex flex-col md:flex-row md:space-x-7.5 gap-y-5 md:gap-y-0 !pt-5 md:!pt-10">
                  <div className="w-full">
                    <input
                      type="text"
                      className="border-b focus:outline-none w-full border-b-midGray  !py-1 md:!py-0 bg-lightGray"
                      placeholder="Email"
                    />
                  </div>
                  <div className="w-full">
                    <input
                      type="text"
                      className="border-b focus:outline-none w-full border-b-midGray  !py-1 md:!py-0 bg-lightGray"
                      placeholder="Phone"
                    />
                  </div>
                </div>
              </div>
              <div className="flex flex-col md:flex-row md:space-x-7.5 gap-y-5 md:gap-y-0 !pt-5 md:!pt-10">
                <div className="w-full">
                  <input
                    type="text"
                    className="border-b focus:outline-none w-full border-b-midGray  !py-1 md:!py-0 bg-lightGray"
                    placeholder="Message"
                  />
                </div>
              </div>
            </div>
            <div className="uppercase text-sm font-halyard  font-medium text-white  py-3 px-7  bg-darkBlue hover:bg-primaryBlue cursor-pointer w-fit  tracking-0.5px flex space-x-3 justify-center items-center mb-0.5">
              <span>
                <img
                  src="/health/images/paper-plane.svg"
                  className="h-4 w-4"
                  alt="paper plane icon"
                />
              </span>
              <span>get in touch</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RegisterAsProvider;
